import { days } from 'config/Vars'
import { ApiCoreEntitiesAccessWeekdayEnum } from 'generated/resources/graphql'
import moment from 'moment'

import { DayOfWeekIndex } from './dates'

// Weekdays as defined in the backend
export type Weekdays = ApiCoreEntitiesAccessWeekdayEnum

export const firstDayOfWeekAsIndex = (
  firstDayOfWeek: Weekdays | null | undefined
): DayOfWeekIndex => {
  if (!firstDayOfWeek) {
    return moment.localeData().firstDayOfWeek() as DayOfWeekIndex
  }

  return days().indexOf(firstDayOfWeek) as DayOfWeekIndex
}

export const firstDayOfWeekAsKey = (firstDayOfWeek: Weekdays | null | undefined) => {
  const firstDayOfWeekFromLocale = days()[moment.localeData().firstDayOfWeek()]

  return firstDayOfWeek || firstDayOfWeekFromLocale
}

export const weekdaysWithUserFirstDayOfWeek = (firstDayOfWeek: Weekdays | null | undefined) => {
  const firstDayOfWeekKey = firstDayOfWeekAsKey(firstDayOfWeek)

  if (!firstDayOfWeekKey) {
    return []
  }

  const firstDayOfWeekIndex = days().indexOf(firstDayOfWeekKey)
  const daysFromFirstDayOfWeek = days().slice(firstDayOfWeekIndex)
  const daysBeforeFirstDayOfWeek = days().slice(0, firstDayOfWeekIndex)

  return [...daysFromFirstDayOfWeek, ...daysBeforeFirstDayOfWeek]
}
